export default __webpack_public_path__ + "static/media/640_dummy2016-architekturbuero01-de.fb00b82c.png";